import { PimResource } from "./pim-resource.js";
import * as PIM from "../pim-vocabulary.js";
/**
 * An association connects two entities, but it does not point to entities
 * directly instead it points to association ends that points to the entities.
 *
 * As association connect two entities without any side preference, i.e. there
 * is no order on the ends, the association does not belong to any class.
 */
export class PimAssociation extends PimResource {
    static TYPE = PIM.ASSOCIATION;
    pimEnd;
    /**
     * If true the order of ends in {@link pimEnd} is from start
     * to end.
     */
    pimIsOriented = false;
    constructor(iri = null) {
        super(iri);
        this.types.push(PimAssociation.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(PimAssociation.TYPE);
    }
}
//# sourceMappingURL=pim-association.js.map